import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <>
        <div className='pt-4 pt-md-5 pb-3 bg-gh footer-Color mt-5'  style={{position:"relative",bottom:"0",width:"100vw"}}>
          <div className='container'>
            
            
            <div className='footer-socials-mobile text-center d-md-none mb-4'>
              <ul className='list-unstyled mb-1'>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-facebook-f text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-twitter text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-pinterest-p text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-instagram text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a href='https://github.com/'>
                    <i className='fab fa-youtube text-white'></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className='footer-info'>
              <div className='row'>

              <div className='col-6 col-md-3 text-white text-left footer-logo  mb-3 mb-md-5'>
                <img src='/imgs/logo/logo.svg' alt='' />
                <h4><i>Trouvez Votre bonheur</i></h4>
                <p className="text-muted">bvd H.Boumedien Local N 5, bt 15 Skikda,21000 Algérie</p>
                <p className="text-muted">Fax : +213 (0) 38 00 00 00
                  Mail : contact@ghurfaty-dz.com</p>

              </div>

                <div className='col-6 col-md-2 mb-3 mb-md-0 '>
                  <div className='website-services'>
                    <h4 className="py-2 text-white font-weight-bold">Catégories</h4>
                    <ul className='list-unstyled'>
                      <li className='mb-2'>
                        <a
                          href='/hebergement'
                          className='text-white text-capitalize active'
                        >
                          Hébergements
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='/visas' className='text-white text-capitalize'>
                          Visas
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='/vols' className='text-white text-capitalize'>
                          Vols
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='/voyages' className='text-white text-capitalize'>
                          Voyages
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='/cars' className='text-white text-capitalize'>
                          Véhicules
                        </a>
                      </li>
                      <li>
                        <a href='/divertissements' className='text-white text-capitalize'>
                          Divertissements
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='col-6 col-md-3  mb-3 mb-md-0 '>
                  <div className='website-about'>
                  <h4 className="py-2 text-white font-weight-bold">À propos</h4>

                    <ul className='list-unstyled'>
                      <li className='mb-2'>
                        <a href='/' className='text-white text-capitalize'>
                         Services
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a
                          href='https://github.com/'
                          className='text-white text-capitalize active'
                        >
                          Espace Pro
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Tarifs
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Coupons
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Parrainage
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Publicites
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='col-6 col-md-2  mb-3 mb-md-0 '>
                  <div className='website-help'>
                  <h4 className="py-2 text-white font-weight-bold">Aide</h4>

                    <ul className='list-unstyled'>
                      <li className='mb-2'>
                        <a
                          href='https://github.com/'
                          className='text-white text-capitalize active'
                        >
                          Support Clients
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Support technique 
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          FAQ
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Litiges
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='col-6 col-md-2  mb-3 mb-md-0 contact-block'>
                  <div className='website-contact'>
                  <h4 className="py-2 text-white font-weight-bold">Ghurfaty & vous</h4>

                    <ul className='list-unstyled'>
                      <li className='mb-2'>
                        <a
                          href='https://github.com/'
                          className='text-white text-capitalize active '
                        >
                          Nous contactez 
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Recrutment
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Blog
                        </a>
                      </li>
                      <li className='mb-2'>
                        <a href='https://github.com/' className='text-white text-capitalize'>
                          Nos engagements
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
            <p className="col-4">
            <button className="loginButton">
              <img src="/imgs/navebar/apple.svg" alt="" />
              <span> app store </span>
              </button>
            <button className="loginButton">
            <img src="/imgs/navebar/google-play.svg" alt="" />
              <span>
               play store
               </span>
             </button>
            </p>
            <ul className='col-4 list-unstyled list-inline pt-3 text-center mb-5' >
              <li className='row list-inline-item px-4'>
              <img src="/imgs/navebar/facebook.svg" className="col-2 p-4" alt="facebook" />
              <img src="/imgs/navebar/twitter.svg" className="col-2 " alt="twitter" />
              <img src="/imgs/navebar/pinterest.svg" className="col-2 " alt="pinterest" />
              <img src="/imgs/navebar/instagram_icon.svg" className="col-2 " alt="instagram" />
              <img src="/imgs/navebar/youtube.svg" alt="col-2 youtube" />
              </li>
            </ul>
            <div className="col-4">


            </div>
            </div>

            {/* <div className='footer-socials text-center mt-5 d-none d-md-block'>
              <ul className='list-unstyled mb-1'>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-facebook-f text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-twitter text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-pinterest-p text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item mr-4'>
                  <a href='https://github.com/'>
                    <i className='fab fa-instagram text-white'></i>
                  </a>
                </li>
                <li className='list-inline-item'>
                  <a href='https://github.com/'>
                    <i className='fab fa-youtube text-white'></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className='footer-copyrights d-none d-md-block'>
              <p className='text-center mb-0'>All rights reserved 2020</p>
            </div> */}
          </div>
        </div>

        <div className='row footer-copyrights-mobile justify-content-center main-bg'>
           <div className='col-8 mb-0 py-2'>
            {/* Ghurfaty.com 2022 © Tous les droit sont résevés */}
          </div>
          <div className='col-4 mb-0 py-2'>
            Ghurfaty.com 2022 © Tous les droit sont résevés
          </div>
        </div>
      </>
    );
  }
}

export default Footer;
